var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00E6A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9786 4.21884C13.0283 4.21775 13.0777 4.22675 13.1238 4.24532C13.1699 4.26388 13.2118 4.29162 13.2469 4.32684L13.2435 4.32346C13.2991 4.37884 13.3354 4.45063 13.347 4.52821L13.3521 4.58671L13.3481 6.50878C13.3481 6.76134 13.248 7.00378 13.0691 7.18209L10.6841 9.55978L13.2362 12.104C13.326 12.1917 13.3974 12.2963 13.4465 12.4118C13.4956 12.5273 13.5213 12.6514 13.5222 12.7769C13.5231 12.9024 13.4991 13.0268 13.4516 13.143C13.4041 13.2591 13.334 13.3647 13.2455 13.4537C13.157 13.5426 13.0517 13.6131 12.9357 13.6612C12.8198 13.7092 12.6955 13.7338 12.57 13.7335C12.4445 13.7332 12.3203 13.708 12.2046 13.6595C12.0889 13.6109 11.9839 13.5399 11.8958 13.4506L8.66983 10.2348C8.58087 10.1466 8.51025 10.0417 8.46206 9.92607C8.41387 9.81045 8.38906 9.68644 8.38906 9.56118C8.38906 9.43593 8.41387 9.31191 8.46206 9.1963C8.51025 9.08068 8.58087 8.97576 8.66983 8.88759L11.4947 6.06834H6.71458V12.7559C6.71672 12.8834 6.69317 13.01 6.64536 13.1282C6.59755 13.2464 6.52645 13.3538 6.43629 13.444C6.34612 13.5341 6.23874 13.6052 6.12053 13.6531C6.00232 13.7009 5.8757 13.7244 5.74821 13.7223L5.65258 13.7189C5.4126 13.698 5.18939 13.5872 5.02777 13.4085C4.86616 13.2299 4.77809 12.9968 4.78127 12.7559V5.25778C4.78127 4.65815 5.21046 4.21884 5.79152 4.21884H12.9786Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReq);
export default __webpack_public_path__ + "static/media/req.5bb644d8671a0154248cdb56730b2c90.svg";
export { ForwardRef as ReactComponent };